// extracted by mini-css-extract-plugin
export default {"Card":"Videos_Card__GZEQf","Img":"Videos_Img__IZI07","title":"Videos_title__QmRna","link":"Videos_link__1qyCo"};